enum ObjectTypeEnum {
    CONSENT = "CONSENT",
    RGPD = "RGPD",
    DIGITAL_DOCUMENT = "DIGITAL_DOCUMENT",
  }

  export default ObjectTypeEnum;